export enum TSwiipePlan {
    None = 0,
    Basic = 1,
    Business = 2,
}
